<!-- =========================================================================================
    File Name: TableAltri.vue
    Description: Table show on Altri documenti
    ----------------------------------------------------------------------------------------
    Item Name: Vuesax Admin - VueJS Dashboard Admin Template
      Author: · | ·· | ·
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <div>
    <search-bar
      :filter_list="$rimb.stati"
      @create-rimborso="handleNewDocumento"
      @find="cercaDocumento"
      :p="{current:this.page,
      tot:this.tot_page}"
      :newTexts="['Rimborso']"
      :tipo="['rimborso']"
      tooltip="Azienda ragione sociale, Contatto nome o cognome"
    />
      <!-- <vs-table @next="nextPage" @prev="prevPage" v-model="selected" @selected="handleSelected" :page="page" :hasNext="hasNext" :pagination="documenti.length >= elements_per_page" :max-items="elements_per_page" :data="documenti"> -->
      <vs-table
        @next="nextPage"
        @prev="prevPage"
        :page="page"
        :hasNext="hasNext"
        :custom_pager="{current:this.page,
        tot:this.tot_page}"
        :pagination="documenti.length >= elements_per_page || page != 1"
        :max-items="elements_per_page"
        :data="documenti"
      >
          <template slot="thead">
            <vs-th
              :key="i"
              v-for="(e, i) in ['Num','Cliente','Ufficio','Servizio','Stato','Datacreazione','Importo']"
            >{{e}}</vs-th>
          </template>
          <template v-if="documenti.length > 0" slot-scope="{data}">
            <vs-tr
              :state="checkStatiRights(tr) ? 'primary' : null" class="shadow row-no-pointer"
              :data="tr"
              :key="indextr"
              v-for="(tr, indextr) in data"
            >

              <vs-td :data="[tr.numero,tr.data_inserimento]" :key="1">
                {{getNumero(tr.numero,tr.data_inserimento)}}
              </vs-td>

              <vs-td :data="data[indextr]" :key="2">
                {{tr.azienda ? tr.azienda.ragione_sociale : [tr.contatto.cognome,tr.contatto.nome].join(' ')}}
              </vs-td>

              <vs-td :data="data[indextr].codice_ufficio" :key="3">
                {{`${tr.ufficio['descrizione']} ( ${tr.ufficio['codice']} )`}}
              </vs-td>
<!-- aggiungere class al td, colorare testo in base alla scadenza -->
              <vs-td :data="data[indextr].servizio" :key="4">
                {{tr.servizio.codice}}
              </vs-td>

              <vs-td :data="data[indextr].stato" :key="5">
                <vx-tooltip :text="data[indextr].stato_label" position="left">
                  <vs-button
                    :color="data[indextr].stato == 'request' ? 'warning' : 'primary'"
                    class="no-pointer-event inline-block p-1"
                    type="flat"
                    icon-pack="feather"
                    :icon="$rimb.icon_of(data[indextr].stato)"
                  />
                </vx-tooltip>
              </vs-td>

              <vs-td :data="data[indextr].data_inserimento" :key="6">
                {{$tariffe.formatDateNew(tr.data_inserimento)}}
              </vs-td>

              <vs-td :data="data[indextr].importo" :key="7">
                {{
                  [
                  new Intl.NumberFormat('it-IT', { maximumFractionDigits: 2 }).format(tr.importo),
                  data[indextr].stato == 'paid' && data[indextr].stati[data[indextr].stati.length-2].stato != 'insurance' ? ` (${new Intl.NumberFormat('it-IT', { maximumFractionDigits: 2 }).format(tr.importo_pagato)})` : '',
                  ' €'
                  ].join('')
                }}
              </vs-td>

              <template class="expand-preventivo" slot="expand" :data="tr">
                <div :key="Math.random()" class="con-expand" >
                  <vs-row class="sidebar-header-row mt-4" vs-justify="flex-start">
                    <vs-col vs-type="flex" vs-justify="right" vs-align="center" vs-w="2">Stato attuale:</vs-col>
                    <vs-col vs-w="10">
                      <ul class="breadcrumbs-two">
                        <li v-for="(el, idx) in data[indextr].stati"
                            :key="idx"
                            v-bind:class="{'current': idx == (data[indextr].stati.length-1),
                                          'default p-0': true,
                                          'notcurrent': el.stato == 'refuse'}">
                          <vs-row vs-align="center">
                             <!-- <b> {{$tir.label_of(staxto.stato)}} </b> -->
                             <vx-tooltip :text="$tariffe.formatDateNew(el.data) + ' - ' + el.stato_label + ' (' + el.utente.nome + ')'" position="left" style="width:min-content;">
                               <vs-button class="no-pointer-event" radius color="black" type="flat" icon-pack="feather" :icon="$rimb.icon_of(el.stato)" />
                             </vx-tooltip>
                             <small v-if="idx == (data[indextr].stati.length-1)">
                               {{
                                 [
                                 $rimb.label_of(el.stato),
                                 ':',
                                 $tariffe.formatDateNew(el.data)
                                 ].join(' ')
                               }}
                             </small>
                          </vs-row>
                        </li>
                      </ul>
                    </vs-col>
                  </vs-row>
                  <vs-row vs-justify="flex-end" class="m-3">
                    <vs-row v-if="tr.azienda || tr.contatto" vs-justify="flex-end">
                      <vx-tooltip text="Visualizza">
                        <vs-button @click="openSidebar(tr, $event)" class="inline-block ml-2" radius color="primary" size="small" type="line" icon-pack="feather" icon="icon-eye" />
                      </vx-tooltip>
                      <vx-tooltip v-if="checUpdatesRights(tr)" text="Modifica">
                        <vs-button @click="handleModificaRimborso(indextr)" class="inline-block ml-2" radius color="warning" size="small" type="line" icon-pack="feather" icon="icon-edit" />
                      </vx-tooltip>
                      <vx-tooltip v-if="checkStatiRights(tr)" text="Cambio Stato">
                        <vs-button @click="open_stato(tr)" class="inline-block ml-2" radius color="success" size="small" type="line" icon-pack="feather" icon="icon-cloud-lightning" />
                      </vx-tooltip>
                      <vx-tooltip text="Genera Pdf">
                        <vs-button @click="generatePDF(tr, $event)" class="inline-block ml-2" radius color="primary" size="small" type="line" icon-pack="feather" icon="icon-download" />
                      </vx-tooltip>
                      <!-- <vx-tooltip text="Aggiungi allegato">
                        <vs-button disabled @click="generatePDF(tr, $event)" class="inline-block ml-2" radius color="primary" size="small" type="line" icon-pack="feather" icon="icon-clipboard" />
                      </vx-tooltip> -->
                      <!-- <vx-tooltip v-if="tr.stato_num < 9" text="Invia">
                        <vs-button disabled @click="inviaDoc(tr, $event)" class="inline-block ml-2" radius color="primary" size="small" type="line" icon-pack="feather" icon="icon-mail" />
                      </vx-tooltip> -->
                    </vs-row>
                  </vs-row>
                </div>
              </template>
              <vs-popup :key="popupKey" class="holamundo text-center" title="Avanza Stato Rimborso" :active.sync="popupStato" style="min-height: 150px;">
                <p class="mb-3">
                  Scegliere lo stato a cui portare il Rimborso
                </p>
                <vs-row class="m-3 mb-6" style="min-height: 100px; width: auto;">
                  <vs-col v-if="tr_ && tr_.stato == 'complete'" vs-offset="4" vs-type="flex" vs-justify="center" vs-align="center" vs-w="4">
                    <vs-checkbox v-model="check_assicurazione">Assicurazione</vs-checkbox>
                    <vs-checkbox v-model="compensazione">Compensazione</vs-checkbox>
                  </vs-col>
                  <vs-col vs-offset="4" vs-type="flex" vs-justify="center" vs-align="center" vs-w="4">
                    <v-select class="mb-3 w-full" v-model="avanza_stato"
                      :options="avaiableStati"
                      :filterable="false"
                      placeholder="Seleziona stato">
                    </v-select>
                  </vs-col>
                  <vs-col v-if="avanza_stato && avanza_stato.id == 'request'" vs-offset="4" vs-type="flex" vs-justify="center" vs-align="center" vs-w="4">
                    <vs-input v-model="causale_modifica" class="w-full" name="causale_modifica" placeholder="Inserisci causale" />
                  </vs-col>
                  <template v-if="(avanza_stato && avanza_stato.id == 'paid') && (tr_ && tr_.stato != 'insurance')">
                    <vs-col class="mb-4" vs-offset="4" vs-type="flex" vs-justify="center" vs-align="center" vs-w="4">
                      <div>
                        {{['Importo: ',new Intl.NumberFormat('it-IT', { maximumFractionDigits: 2 }).format(tr_.importo),'€'].join(" ")}}
                      </div>
                    </vs-col>
                    <vs-col vs-offset="4" vs-type="flex" vs-justify="center" vs-align="center" vs-w="4">
                      <vs-input class="w-full" v-currency="{}" v-model="importo_pagato" name="importo_pagato"  placeholder="Inserisci importo pagato" />
                    </vs-col>
                  </template>
                </vs-row>
                <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="12">
                  <vs-button :disabled="is_loading" @click="commitStato(tr_)" icon-pack="feather" icon="icon-cloud-lightning" type="line" color="success"> Cambia Stato </vs-button>
                </vs-col>
              </vs-popup>
            </vs-tr>
          </template>
      </vs-table>
      <vs-sidebar click-not-close position-right parent="body" color="primary" class="sidebarx sidebarpage sidebar-documento" spacer v-model="sidebar_active">
        <sidebar-new-rimborso @close-me="sidebarClose" @elimina="handleEliminaDocumento" @rimborso-creato="handleDocumentoCreato" v-if="sidebar_type === 'rimborso'" :key="Math.random()" :selected="_.cloneDeep(selected)" :isResponsabile="selected && userIsResponsabileServizio(selected.servizio.codice)"></sidebar-new-rimborso>
        <sidebar-rimborso @close-me="sidebarClose" v-if="sidebar_type === 'rimborso-view'" :key="Math.random()" :selected="_.cloneDeep(selected)"></sidebar-rimborso>
        <!-- <sidebar-mail @mail-inviata="sentMail" @close-me="sidebarClose" v-else-if="sidebar_type === 'mail' && selected" :stato_inviato="inviato.id" :selected="selected" :key="formkey" /> -->
<!-- SIDEBAR UPLOAD -->
      </vs-sidebar>
      <vs-sidebar click-not-close parent="body" spacer position-right color="primary" class="sidebar-utenti" v-model="sidebar_small_active">
        <SelectorWithInput @close-me="sidebarClose" :stati="stati" :selected="tr_" v-if="sidebar_type === 'confirm'" :key="formkey" ></SelectorWithInput>
      </vs-sidebar>
  </div>
</template>

<script>
import axios from 'axios'
import SidebarNewRimborso from './SidebarNewRimborso.vue'
import SidebarRimborso from './SidebarRimborso.vue'
import SearchBar from '../commons/SearchBar.vue'
// import SidebarMail from './SidebarMail.vue'
import SelectorWithInput from './SelectorWithInput.vue'

export default {
    data() {
        return {
          is_loading: null,

          selected: null,

          sidebar_type: '',
          sidebar_active: false,
          sidebar_small_active: false,
          documenti: [],

          formkey: Math.random(),

          keyword: "",
          page: 1,
          tot_page: 0,
          elements_per_page: 15,
          hasNext: false,

          avanza_stato: 0,
          causale_eliminato_text: '',
          causale_modifica: '',
          importo_pagato: null,
          popupDelete: false,
          popupStato: false,
          popupKey: null,
          tr_: { stato: {} },
          check_assicurazione: false,
          compensazione: false,
          // user
          userId: localStorage.utente_id,
          userMail: localStorage.utente_mail,
          userSettings: localStorage.deep_settings,
          userObjSettings: null,
        }
    },
    components: {
      SidebarNewRimborso,
      SidebarRimborso,
      SearchBar,
      SelectorWithInput,
    },
    mounted () {
      this.getDocumenti()
      if (this.userSettings) {
        // console.log(this.userSettings);
        this.objSettings = JSON.parse(this.userSettings);
      }
      if (this.$route.params.wanted_id) {
        setTimeout(() => this.openWanted(this.$route.params.wanted_id), 500)
      }
    },
    computed: {
      avaiableStati: {
        get () {
      // console.log('QUI ',this.tr_,this.tr_.stato_num);
          // avoid selecting 'Richiesta modifca' stato
          // if (this.tr_.stato_num == 3) return [this.$rimb.stati.find( item => item.num == 6)]
          // else {
            let x = this.$rimb.stati.filter( item => item.num > this.tr_.stato_num && item.num <= this.tr_.stato_num + 1)

            // Verificato - CASE utente è resposabile servizio
            if (this.tr_ && this.tr_.creatore) {
              if (this.tr_.creatore.permessi
                && (this.tr_.creatore.permessi == 2
                  && !this.tr_.creatore.id_responsabile)
                // || (this.tr_.creatore.permessi < 2 )
                || (this.tr_.creatore.permessi < 2 && this.tr_.creatore.id_responsabile &&
                    JSON.parse(this.tr_.creatore.responsabile.deep_settings) &&
                    JSON.parse(this.tr_.creatore.responsabile.deep_settings.rimborsi.resp).includes(this.tr_.servizio.codice))
              ) {
                x = [] // to remove Approvato
                x.push(this.$rimb.stati.find( item => item.num == 2)) // 2 is Verificato
                // x.push(this.$rimb.stati.find( item => item.num == 3)) // 3 is Confermato
              }
            }

            // in stato Modificato - handle like Creato
            if (this.tr_ && this.tr_.stato_num == 5)
              x = this.$rimb.stati.filter( item => item.num > 0 && item.num <= 1)

            // in stato Completato - Conclusa
            if (this.tr_ && this.tr_.stato_num == 6)
              x = this.$rimb.stati.filter( item => item.num > 7 && item.num < 9)

            // add Richiesta Modifica - no in Completato o Conclusa o Rifiutato - non per Utente
            if (this.tr_ && this.tr_.stato_num < 6 && this.tr_.stato_num != 3 && localStorage.utente_permessi != 2)
              x.push(this.$rimb.stati.find( item => item.num == 4))

            if (this.check_assicurazione) x.push(this.$rimb.stati.find( item => item.num == 7))
            if (this.tr_ && this.tr_.stato_num == 3) x.push(this.$rimb.stati.find( item => item.num == 6))
            if (this.tr_ && this.tr_.stato_num < 8) x.push(this.$rimb.stati.find( item => item.num == 9))
            return x
          // }
        },
      },
      currentUserEmail() {
        return localStorage.utente_mail
      },
    },
    methods: {
      openWanted(id) {
        axios.post(process.env.VUE_APP_BACKEND_API+'/rimborso/get', {
          id: id,
        },{
          headers: { "Access-Control-Allow-Origin": "*", 'Content-Type': 'application/json',},
          withCredentials: true,
        }).then(response => {
          if (response.data) {
            this.openSidebar(response.data)
          }
        })
        // .catch(e => { console.log(e) })
        // let wanted_prev = this.documenti.find( r => r.id == this.$route.params.wanted_id )
      },
      getDocumenti() {
        this.activeLoading = true
        this.$vs.loading({
          type:'radius',
        })
        axios.post(process.env.VUE_APP_BACKEND_API+'/rimborso/trova', {
          pag: this.page,
          option: this.option && this.option.label ? this.option.label : "Tutti",
          keyword: this.keyword,
          take: this.elements_per_page
        },{
          headers: { "Access-Control-Allow-Origin": "*", 'Content-Type': 'application/json',},
          withCredentials: true,
        })
        .then(response => {
          if (response.data.length == 0) {  this.documenti = []
                                            this.hasNext = false }
          else {
            this.documenti = response.data.res
            this.hasNext = this.documenti.length >= this.elements_per_page
            this.tot_page = Math.ceil(response.data.count / this.elements_per_page)
            // this.selected = this.selected ? this.documenti.find( a => a.id == this.selected.id) : {}
          }
          this.$vs.loading.close()
        })
        .catch(e => {
          // console.log(e)
          this.$vs.loading.close()
        })
      },
      nextPage() {
        if (this.page < this.tot_page) {
          this.page += 1
          this.getDocumenti()
        }
      },
      prevPage() {
        this.page -= 1
        this.getDocumenti()
      },
      handleNewDocumento() {
        if (this.selected) {
          this.selected = null
        }
        this.sidebar_type = 'rimborso'
        this.formkey = Math.random()
        this.sidebar_active = true
      },
      handleDocumentoCreato(message) {
        if (message === 'OK') {
          this.sidebar_active = false
          this.formkey = Math.random()

          this.page = 1
          this.keyword = ""
          this.selected = null
          this.getDocumenti()
          // console.log(message);
        }
      },
      handleModificaRimborso(idx) {
        this.selected = this.documenti[idx]
        this.formkey = Math.random()
        this.sidebar_type = 'rimborso'
        this.sidebar_active = true
      },
      handleEliminaDocumento(id) {
        this.formkey = Math.random()
        axios.post(process.env.VUE_APP_BACKEND_API+'/azienda/documento/elimina', { id: id },{
            headers: { "Access-Control-Allow-Origin": "*", 'Content-Type': 'application/json',},
            withCredentials: true,
          })
          .then(response => {
            this.sidebar_active = false
            this.message = response.data
            this.formkey = Math.random()
            this.getDocumenti()
            this.selected = null
          } )
          // .catch(e => console.log(e))
      },
      cercaDocumento(k,opt) {
        this.keyword = k
        this.option = opt
        this.page = 1
        this.getDocumenti()
      },
      handleSelected(doc) {
        // if(this.selected) {
          this.selected = _.cloneDeep(doc)
          this.formkey = Math.random()
          this.sidebar_active = true
        // }
      },
      generatePDF(rimborso, ev) {
        this.activeLoading = true
        this.$vs.loading({
          type:'radius',
        })
        let p_to_print = _.cloneDeep(rimborso)
// console.log(rimborso,p_to_print);
        axios.post(process.env.VUE_APP_BACKEND_API+'/rimborso/generate_file', {
          templates: [{nuovo_nome: 'rimborso.docx'}],
          object: this.$rimb.generatePDFrimborso(p_to_print),
        },{
          headers: { "Access-Control-Allow-Origin": "*", 'Content-Type': 'application/json',},
          withCredentials: true,
          responseType: 'blob'
        })
        .then(
          response => {
            const url = window.URL.createObjectURL(new Blob([response.data], {type:'application/octet-stream'}));
            const link = document.createElement('a');
            link.href = url
            this.$vs.loading.close()
            link.setAttribute('download', response.headers['x-file-name']);
            document.body.appendChild(link);
            link.click();
          }
        )
        .catch(e => {
          // console.log(e)
          this.$vs.loading.close()
          this.$vs.notify({
            color: 'warning',
            time: 4000,
            title: ['Errore nel modello'].join(' '),
            text: ['Malformato o inesistente'].join(' ')
          })
        })
        ev.stopPropagation()
      },
      openSidebar(data) {
        this.formkey = Math.random()
        this.sidebar_type = 'rimborso-view'
        this.sidebar_active = true
        this.selected = data
      },
      getNumero(n,date) {
        let d_n = new Date(date).getYear() + 1900
        return [n,'/',d_n].join('')
      },
      open_stato(rimborso) {
        this.tr_ = rimborso
        this.popupStato = true
        this.avanza_stato = 0
        this.causale_modifica = ''
        this.importo_pagato = null
        this.popupKey = Math.random()
      },
      commitStato(rimborso) {
        // e.preventDefault();
        this.is_loading = true
        let s_ordine = this.avanza_stato.value
        let obj = {
          id: rimborso.id,
          item: rimborso,
          stato: this.avanza_stato.id,
          stato_num: this.avanza_stato.num,
          stato_label: this.avanza_stato.label,
        }
        if (obj.stato_num == 4 && !this.causale_modifica.length) {
          this.$vs.notify({
            color: 'warning',
            time: 4000,
            title: ['Attenzione'].join(' '),
            text: ['Inserire una causale per procedere con il cambio stato'].join(' ')
          })
          this.popupStato = false
          this.is_loading = false
        }
        else if (obj.stato_num == 8 && (rimborso.stato != 'insurance' && !this.importo_pagato)) {
          this.$vs.notify({
            color: 'warning',
            time: 4000,
            title: ['Attenzione'].join(' '),
            text: ['Inserire importo pagato per procedere con il cambio stato'].join(' ')
          })
          this.popupStato = false
          this.is_loading = false
        }
        else {
          if (obj.stato_num == 4) obj['causale_modifica'] = this.causale_modifica
          if (obj.stato_num == 8 && rimborso.stato != 'insurance') obj['importo_pagato'] = this.$parseCurrency(this.importo_pagato)
          if (this.compensazione) obj['compensazione'] = this.compensazione
          let url = process.env.VUE_APP_BACKEND_API+'/rimborso/avanza_stato'
          axios.post(url, obj,{
            headers: { "Access-Control-Allow-Origin": "*", 'Content-Type': 'application/json',},
            withCredentials: true,
          })
          .then(response => {
            this.$vs.notify({
              color: this.avanza_stato.label == 'Rifiutato' ? 'danger' : 'success',
              time: 4000,
              title: ['Rimborso N°',rimborso.numero].join(' '),
              text: ['Passato a',this.avanza_stato.label].join(' '),
              icon:'mail'
            })
            this.avanza_stato = 0
            this.tr_ = { stato: {} }
            this.popupStato = false
            this.getDocumenti()
            this.is_loading = false
            // this.$emit('stato-avanzato')
          })
        }
      },
      sidebarClose() {
        this.selected = null
        this.sidebar_active = false
      },
      userIsResponsabileServizio(str) {
        if (!this.objSettings) {
          return false;
        }

        const respArray = this.objSettings.rimborsi.resp;
        if (Array.isArray(respArray) && respArray.length > 0) {
          return respArray.includes(str);
        }

        return false;
      },
      checkStatiRights(rimborso) {
        if (rimborso.stato_num > 7) return false
        else {
          const creatore = rimborso.creatore
          const userId = localStorage.utente_id
          const userMail = localStorage.utente_mail
        // in stato Creato
          if (rimborso.stato_num == 0) {
            // console.log(rimborso.numero, rimborso.id, this.userIsResponsabileServizio(rimborso.servizio.codice));
            if (rimborso.id_creatore == userId && this.userIsResponsabileServizio(rimborso.servizio.codice)) return true
            else if (rimborso.id_creatore == userId) return false
            else if (creatore.permessi == 2 && creatore.id_responsabile && creatore.id_responsabile == userId) return true
            else if ((creatore.permessi != 2 || !creatore.id_responsabile) && this.userIsResponsabileServizio(rimborso.servizio.codice)) return true
          }
        // in stato Approvato
          else if (rimborso.stato_num == 1 && this.userIsResponsabileServizio(rimborso.servizio.codice)) return true
        // in stato Verificato
          else if (rimborso.stato_num == 2 && (userMail == 'amministrazione@ascom.bo.it' || userMail == 'amministrazione@harakirimail.com')) return true
        // in stato Confermato
          else if (rimborso.stato_num == 3 && (userMail == 'stefano.giorgi@ascom.bo.it' || userMail == 'direzione@harakirimail.com')) return true
        // // in stato Richiesta modifica
          // else if (rimborso.stato_num == 4 && rimborso.id_creatore == userId) return true // MUST BE FALSE
        // in stato Modificato - like Creato
          else if (rimborso.stato_num == 5) {
            if (rimborso.id_creatore == userId) return false
            else if (creatore.permessi == 2 && creatore.id_responsabile && creatore.id_responsabile == userId) return true
            else if ((creatore.permessi != 2 || !creatore.id_responsabile) && this.userIsResponsabileServizio(rimborso.servizio.codice)) return true
          }
        // in stato Completato
          else if (rimborso.stato_num == 6 && (userMail == 'amministrazione@ascom.bo.it' || userMail == 'amministrazione@harakirimail.com')) return true
        // in stato Assicurazione e dati ass. completi
          else if (rimborso.stato_num == 7 && rimborso.data_liquidazione_assicurazione && (userMail == 'amministrazione@ascom.bo.it' || userMail == 'amministrazione@harakirimail.com')) return true
        }
        return false
      },
      checUpdatesRights(rimborso) {
        const userId = localStorage.utente_id
        const userMail = localStorage.utente_mail
        if ((rimborso.stato_num == 0 || rimborso.stato_num == 4) && (rimborso.id_creatore == userId))
          return true
        else if (rimborso.stato_num == 0 && this.userIsResponsabileServizio(rimborso.servizio.codice))
          return true
        else if ((rimborso.stato_num == 7) && (userMail == 'amministrazione@ascom.bo.it' || userMail == 'amministrazione@harakirimail.com'))
          return true
        else return false
      }
    },
}
</script>
